import { createBrowserRouter, Navigate } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute.tsx";
import { AdminLayout } from "./pages/AdminLayout.tsx";
import { LoginPage } from "./pages/LoginPage.tsx";
import { DataPage } from "./pages/DataPage.tsx";
import { OrganizationsPage } from "./pages/OrganizationsPage.tsx";
import { OrgDetailPage } from "./pages/OrgDetailPage.tsx";
import { UsersPage } from "./pages/UsersPage.tsx";
import { UserDetailPage } from "./pages/UserDetailPage.tsx";
import { UsagePage } from "./pages/UsagePage.tsx";
import { PlansPage } from "./pages/PlansPage.tsx";
import { PlanDetailPage } from "./pages/PlanDetailPage.tsx";
import { IncidentsPage } from "./pages/IncidentsPage.tsx";
import { PlaygroundPage } from "./pages/PlaygroundPage.tsx";
import { AiQueriesPage } from "./pages/AiQueriesPage.tsx";
import { EmailsPage } from "./pages/EmailsPage.tsx";
import { LeadsPage } from "./pages/LeadsPage.tsx";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DataPage /> },
      { path: "organizations", element: <OrganizationsPage /> },
      { path: "organizations/:id", element: <OrgDetailPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "users/:id", element: <UserDetailPage /> },
      { path: "emails", element: <EmailsPage /> },
      { path: "leads", element: <LeadsPage /> },
      { path: "usage", element: <UsagePage /> },
      { path: "plans", element: <PlansPage /> },
      { path: "plans/:id", element: <PlanDetailPage /> },
      { path: "status", element: <IncidentsPage /> },
      { path: "playground", element: <PlaygroundPage /> },
      { path: "ai-queries", element: <AiQueriesPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
